import { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { musteriTelefonToplu } from '../services/santralYonetimService';
import { normalizeTurkishPhone } from '../utils/phoneNormalize';

/**
 * Telefon listesi için müşteri ad-soyad haritası (0 / +90 / 90 uyumlu arama).
 */
export function useMusteriTelefonMap(telefonlar, { aktif = true } = {}) {
  const [map, setMap] = useState({});
  const cacheRef = useRef({});

  const normalizedList = useMemo(() => {
    const keys = new Set();
    (telefonlar || []).forEach((t) => {
      const n = normalizeTurkishPhone(t);
      if (n.length === 10) keys.add(n);
    });
    return [...keys].sort();
  }, [telefonlar]);

  const listKey = normalizedList.join('|');

  useEffect(() => {
    if (!aktif || normalizedList.length === 0) {
      setMap({});
      return undefined;
    }

    const missing = normalizedList.filter((k) => !cacheRef.current[k]);
    if (missing.length === 0) {
      const slice = {};
      normalizedList.forEach((k) => {
        if (cacheRef.current[k]) slice[k] = cacheRef.current[k];
      });
      setMap(slice);
      return undefined;
    }

    let cancelled = false;
    musteriTelefonToplu(missing)
      .then((res) => {
        if (cancelled) return;
        const veri = res?.veri || {};
        Object.entries(veri).forEach(([k, v]) => {
          cacheRef.current[k] = v;
        });
        const slice = {};
        normalizedList.forEach((k) => {
          if (cacheRef.current[k]) slice[k] = cacheRef.current[k];
        });
        setMap(slice);
      })
      .catch(() => {
        if (!cancelled) setMap({});
      });

    return () => { cancelled = true; };
  }, [aktif, listKey, normalizedList]);

  const getAdSoyad = useCallback((telefon) => {
    const key = normalizeTurkishPhone(telefon);
    if (!key) return null;
    return map[key]?.adSoyad || null;
  }, [map]);

  return { getAdSoyad, map };
}

export default useMusteriTelefonMap;
